import React from "react";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import "./Calculator.scss";

import Mortgage from "./Sections/Mortgage";
import StampDuty from "./Sections/StampDuty";

const Calculator = ({price, department}) => {

    var stamp_calcul_tab = process.env.GATSBY_STAMPDUTY_COUNTRY === "SCOTLAND" ? "LBTT Calculator" : "Stamp Duty Calculator";

    const eventCall = (event) => {
        //console.log("calculator_type", event.target.textContent)
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'calculator',
            'formType': event.target.textContent,
            'formName': event.target.textContent,
            'formLabel': event.target.textContent
        });
    }
    
    return (
        <React.Fragment>
            <section className="calculator">
                <div className="calculate">
                    <div className="h3">Property Calculators</div>
                    {/* <Tabs defaultActiveKey="mortgage" onClick={eventCall}> */}
                    <Tabs defaultActiveKey="mortgage">
                        <Tab eventKey="mortgage" title="Mortgage Calculator">
                            <Mortgage price={price}/>
                        </Tab>
                        <Tab eventKey="stamp_duty" title={stamp_calcul_tab}>
                            <StampDuty price={price} department={department} title={stamp_calcul_tab}/>
                        </Tab>
                    </Tabs>
                </div>

            </section>
        </React.Fragment>
    );
};
export default Calculator;
